export default "__VITE_ASSET__BuNvxA9q__"